import React, { Component } from "react";
import ReactGA from "react-ga";
import { DragSource } from "react-dnd";
import { getEmptyImage } from "react-dnd-html5-backend";

import { playChar } from "../../sounds";
import { DND_KEY } from "../../constants";
import Key from "./Key";

const dragSource = {
  canDrag: ({ draggable }) => draggable,
  beginDrag: ({ char, hint }) => {
    if (hint) {
      playChar(char);
    }

    return { char };
  }
};

const collect = connect => ({
  connectDragSource: connect.dragSource(),
  connectDragPreview: connect.dragPreview()
});

@DragSource(DND_KEY, dragSource, collect)
export default class KeyContainer extends Component {
  static defaultProps = {
    draggable: true
  };

  componentDidMount = () => {
    // Use empty image as a drag preview so browsers don't draw it
    // and we can draw whatever we want on the custom drag layer instead.
    this.props.connectDragPreview(getEmptyImage(), {
      // IE fallback: specify that we'd rather screenshot the node
      // when it already knows it's being dragged so we can hide it with CSS.
      captureDraggingState: true
    });
  };

  handleClick = () => {
    const { char, setValue, hint } = this.props;

    if (hint) {
      playChar(char);
    }

    setValue(char);

    ReactGA.event({
      category: "Input type",
      action: "Click"
    });
  };

  render = () => {
    const { connectDragSource } = this.props;

    return connectDragSource(
      <div onClick={this.handleClick}>
        <Key {...this.props} />
      </div>
    );
  };
}



// WEBPACK FOOTER //
// ./src/components/Keyboard/KeyContainer.js